import { faClose } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { Button, IconButton, Tooltip, Typography } from 'procyon-ui'
import React, { useEffect, useState } from 'react'
import { parsePem64 } from 'Utils/certificateParser'
import { enqueueNotification } from 'Utils/Helpers'
import { CopyText, FullScreenContentModal, JSONPrettyView, LabelContent } from 'V2Components'

function CertificateInfo({ cert, title }) {
  const [decodedCert, setDecodedCert] = useState(null)
  const [viewMore, setViewMore] = useState(false)
  const [viewRAW, setViewRAW] = useState(false)
  const decodeCertificate = () => {
    try {
      const decoded = parsePem64(cert)
      setDecodedCert(decoded)
    } catch (error) {}
  }

  useEffect(() => {
    decodeCertificate()
  }, [cert])

  return (
    <div>
      <Typography variant='h4-medium'>{title}</Typography>
      <LabelContent title='Common Name' content={decodedCert?.Subject?.CN || ''} />
      <LabelContent title='Organization' content={decodedCert?.Subject?.O || ''} />
      <LabelContent title='Organization Unit' content={decodedCert?.Subject?.OU || ''} />
      <LabelContent title='Country' content={decodedCert?.Subject?.C || ''} />
      <LabelContent
        title='Valid From'
        content={moment(decodedCert?.Validity.NotAfter).format('LLL')}
      />
      <LabelContent
        title='Valid To'
        content={moment(decodedCert?.Validity.NotBefore).format('LLL')}
      />
      <LabelContent title='Issuer' content={decodedCert?.Issuer?.CN || ''} />
      <LabelContent title='Serial Number' content={decodedCert?.SerialNumber.Hex || ''} />
      <div className='mt-4 flex items-center justify-start gap-4'>
        <Button onClick={() => setViewMore(true)} variant='gray'>
          View More Certificate Info
        </Button>
        <Button onClick={() => setViewRAW(true)} variant='gray'>
          View Raw Certificate
        </Button>
      </div>
      <div>
        {viewMore && (
          <FullScreenContentModal>
            <div className='flex justify-between items-center'>
              <Typography variant='h4-regular'>{title}</Typography>
              <IconButton icon={faClose} variant='gray' onClick={() => setViewMore(false)} />
            </div>
            <div className='mt-4'>
              <JSONPrettyView height='500px' data={decodedCert} />
            </div>
          </FullScreenContentModal>
        )}
        {viewRAW && (
          <FullScreenContentModal>
            <div className='flex justify-between items-center'>
              <Typography variant='h4-regular'>{title}</Typography>
              <IconButton icon={faClose} variant='gray' onClick={() => setViewRAW(false)} />
            </div>
            <div className=''>
              <CopyText
                Component={
                  <div className='mt-4 h-[400px] mb-4 bg-gray-100'>
                    <Tooltip title='Click to Copy' arrow>
                      <div className='p-2 rounded bg-gray-100 cursor-copy'>
                        <Typography className='!break-all' variant='body-regular'>
                          <code>
                            <pre>{cert}</pre>
                          </code>
                        </Typography>
                      </div>
                    </Tooltip>
                  </div>
                }
                messageKey={title}
                text={cert}
              />
            </div>
          </FullScreenContentModal>
        )}
      </div>
    </div>
  )
}

export { CertificateInfo }
